import { useDispatch, useSelector } from "react-redux";
import {
  selectAuth,
  selectUserRoles,
} from "../../SharedModule/redux/reducers/auth.reducer";
import { getHostUrl } from "../../ProductsModule/utils/reportsUtils";
import { TelerikReport } from "../../SharedModule/components/TelerikReport";
import { useEffect } from "react";
import { setActiveTab } from "../../SharedModule/redux/reducers/uiShared.reducer";
import { ROUTE_CLIENTS_REPORTS } from "../../SharedModule/utils/constants";
import { Spinner } from "../../SharedModule/components/Spinner";
import { verifyModuleAccess } from "../../SharedModule/utils/accessUtils";
import { ForbiddenPage } from "../../SharedModule/pages/ForbiddenPage";

// Shared by the ClientsModule reportPages: each is a thin wrapper around a
// single Telerik report that differs only in title, report file, which
// roles can see it, whether it shows its own parameters area, and whether
// it needs the extra ImportDate parameter (HubSpot report only).
export const ClientTelerikReportPage = ({
  documentTitle,
  reportTitle,
  reportName,
  allowedRoles,
  parametersAreaVisible,
  includeImportDate = false,
}: {
  documentTitle: string;
  reportTitle: string;
  reportName: string;
  allowedRoles: string[];
  parametersAreaVisible: boolean;
  includeImportDate?: boolean;
}) => {
  const auth = useSelector(selectAuth);
  const dispatch = useDispatch();
  const { userRolesList, rolesLoaded } = useSelector(selectUserRoles);

  let parameters: any = {
    HostUrl: getHostUrl(),
    Auth: auth.accessToken,
  };
  if (includeImportDate) {
    // to help telerik reports to get correct local timezone
    const today = new Date();
    parameters.ImportDate = new Date(
      Date.UTC(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        today.getHours(),
        today.getMinutes(),
        today.getSeconds()
      )
    );
  }

  useEffect(() => {
    document.title = documentTitle;
    dispatch(setActiveTab(ROUTE_CLIENTS_REPORTS));
  }, []);

  return (
    <>
      {!rolesLoaded && (
        <Spinner
          style={{
            marginLeft: "50%",
            marginTop: "5%",
          }}
        />
      )}
      {rolesLoaded &&
        !verifyModuleAccess(true, allowedRoles, userRolesList) && (
          <ForbiddenPage />
        )}
      {rolesLoaded && verifyModuleAccess(true, allowedRoles, userRolesList) && (
        <TelerikReport
          title={reportTitle}
          reportName={reportName}
          parameters={parameters}
          parametersAreaVisible={parametersAreaVisible}
          backButtonText="Back to Client Reports"
          backButtonRoute={ROUTE_CLIENTS_REPORTS}
        />
      )}
    </>
  );
};
